/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PcnSyncSettingTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const pcnSyncSettingFetchItemOptionLoading = (state, { boolean }) => ({
  ...state,
  itemIsLoading: boolean
});

export const pcnSyncSettingFetchItemOptionSuccess = (state, { options }) => ({
  ...state,
  itemOptions: options
});

export const pcnSyncSettingSaveSettingSuccess = (state, { settings }) => ({
  ...state,
  settings
});
export const pcnSyncSettingSaveSettingLoading = (state, { settingIsLoading }) => ({
  ...state,
  settingIsLoading
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PcnSyncSettingTypes.PCN_SYNC_SETTING_FETCH_ITEM_OPTION_LOADING]: pcnSyncSettingFetchItemOptionLoading,
  [PcnSyncSettingTypes.PCN_SYNC_SETTING_FETCH_ITEM_OPTION_SUCCESS]: pcnSyncSettingFetchItemOptionSuccess,

  [PcnSyncSettingTypes.PCN_SYNC_SETTING_SAVE_SETTING_SUCCESS]: pcnSyncSettingSaveSettingSuccess,
  [PcnSyncSettingTypes.PCN_SYNC_SETTING_SAVE_SETTING_LOADING]: pcnSyncSettingSaveSettingLoading
});
